import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import { useFormContext } from 'modules/client/legal/forms/companyBankAccountsForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const CompanyBankAccountsSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();
  const { readOnly, values, setFieldValue } = useFormContext();

  const onAddBankAccount = () => {
    const bankAccounts = [
      ...values.bankAccounts,
      {
        swiftCode: '',
        country: null,
        hasPermanentManagementInCountry: null,
        onTerritoryWithNoAML_CFT: null,
      },
    ];
    setFieldValue('bankAccounts', bankAccounts, false);
  };

  const onRemoveBankAccount = (index: number) => {
    const bankAccounts = [...values.bankAccounts];
    bankAccounts.splice(index, 1);
    setFieldValue('bankAccounts', bankAccounts, false);
  };

  return (
    <Section
      datax="companyBankAccountsSection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAddBankAccount}
          />
        )
      }
      title={t('client.legal.companyBankAccounts.title')}
    >
      <FormContent {...formProps} onRemoveBankAccount={onRemoveBankAccount} />
    </Section>
  );
};
